import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageMexicoCity = props => {
  return (
    <CityLandingPage
      cityKey="MexicoCity"
      cityConfig={cityContent.mexicoCity}
      cityLabel="mexicoCity"
      {...props}
    />
  );
};

export default LandingPageMexicoCity;
